/**************************************************
 * Nombre:       Seccion_Detalle_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Detalle_Producto_Img_Caracteristicas from "./Componentes/Detalle_Producto_Img_Caracteristicas";
import Detalle_Producto_Match from "./Componentes/Detalle_Producto_Match";
import Lista_Productos from "./Componentes/Lista_Productos";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {useParams} from "react-router";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Detalle_Producto = () => {
    const {sCell} = useResponsive()
    const parms = useParams()
    const [producto, setProducto] = useState({})
    const [arrProductos, setArrProductos] = useState([])

    const quitarDuplicados = (arr) => {

        const mapa = new Map();

        arr.forEach(item => {
            // Usamos el número de celular como llave (key)
            mapa.set(item.id, item);
        });

        // Convertimos los valores del mapa de nuevo a un array
        setArrProductos(Array.from(mapa.values()))

    }


    useEffect(() => {
        irArriba()

        if (parms && parms.id) {
            obtenerDoc('productos', parms.id).then((dox) => {
                if (dox.res) {
                    setProducto(dox.data)
                }
            })
        }

    }, [parms]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 6}}>
                <Detalle_Producto_Img_Caracteristicas producto={producto}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? 4 : 8}}>
                <Detalle_Producto_Match producto={producto} setArrProductos={quitarDuplicados}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: sCell ? 4 : 8, mb: 12}}>
                <Lista_Productos productos={arrProductos}/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Detalle_Producto